import Utils from "@/utilities/Utils";

export class EmailLogSearchParameters {
    pageNumber: number = 1;
    id: string = Utils.emptyGuidValue;
    awsMessageID: string = "";
    visitID: string = Utils.emptyGuidValue;
    searchText: string = "";
}
